import { render, staticRenderFns } from "./Back.vue?vue&type=template&id=91f0eed4&scoped=true&"
var script = {}
import style0 from "./Back.vue?vue&type=style&index=0&id=91f0eed4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91f0eed4",
  null
  
)

export default component.exports